module.exports = __webpack_public_path__ + "img/powerLogoC1_7.46f079f6.png";